var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "loading-mask" }, [
    _c(
      "div",
      { staticClass: "breadcrumb-layout" },
      [
        _c(
          "el-breadcrumb",
          { attrs: { separator: "/" } },
          [
            _c("el-breadcrumb-item", { attrs: { to: { path: "/" } } }, [
              _vm._v("服务请求管理")
            ]),
            _vm._v(" "),
            _c("el-breadcrumb-item", [_vm._v("请求列表")])
          ],
          1
        ),
        _vm._v(" "),
        _vm.back
          ? _c(
              "div",
              {
                staticClass: "right",
                on: {
                  click: function($event) {
                    _vm.goBack()
                  }
                }
              },
              [_vm._m(0)]
            )
          : _vm._e()
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "column-layout clearfix" }, [
      _c(
        "div",
        {
          staticClass: "left-column fl",
          class: { "show-current": _vm.back, active: !_vm.treeCollapse }
        },
        [
          _vm._m(1),
          _vm._v(" "),
          _c(
            "div",
            {
              staticStyle: { "overflow-y": "auto" },
              attrs: { id: "tree-menu" }
            },
            [
              _c("swb-org-tree", {
                attrs: {
                  searchSize: "mini",
                  showIncludeSubComs: true,
                  enableSearch: true
                },
                on: {
                  "notity-change": function($event) {
                    _vm.notityChange($event)
                  },
                  "show-tree-collapse": function($event) {
                    _vm.showTreeCollapse($event)
                  }
                }
              })
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading"
            }
          ],
          staticClass: "right-column fl"
        },
        [
          _c(
            "div",
            [
              _c("swb-query-sort-area", {
                ref: "query_model",
                attrs: {
                  config: _vm.queryConfig,
                  queryKey: _vm.queryKey,
                  queryHandler: _vm.queryHandler
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          !_vm.back
            ? _c(
                "div",
                {
                  staticStyle: {
                    "background-color": "#fafafa",
                    "line-height": "49px",
                    height: "49px"
                  }
                },
                [
                  _c("span", { staticClass: "ml15" }, [
                    _vm._v("当前公司："),
                    _vm.comInfo.id != null
                      ? _c("span", [_vm._v(_vm._s(_vm.comInfo.name))])
                      : _c("span", [_vm._v("无")])
                  ])
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "mt10 mb10" }, [
            _vm.deviceId != null && _vm.servcReqVoucherList.length > 0
              ? _c("span", { staticClass: "mr20" }, [
                  _vm._v(
                    "设备名称：" + _vm._s(_vm.servcReqVoucherList[0].goodsTitle)
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.svcSubNo != null
              ? _c("span", [_vm._v("服务子号：" + _vm._s(_vm.svcSubNo))])
              : _vm._e(),
            _vm._v(" "),
            _vm.tmpNo != null
              ? _c("span", [_vm._v("系统编号：" + _vm._s(_vm.tmpNo))])
              : _vm._e()
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "table-layout" },
            [
              _c(
                "el-table",
                { attrs: { data: _vm.servcReqVoucherList, border: "" } },
                [
                  _c("el-table-column", {
                    staticClass: "align-left",
                    attrs: {
                      prop: "buyerShopName",
                      width: "150",
                      label: "请求机构"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    staticClass: "align-left",
                    attrs: {
                      prop: "requestTime",
                      width: "150",
                      label: "请求时间"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    staticClass: "align-left",
                    attrs: {
                      prop: "buyerContactName",
                      width: "80",
                      label: "机构联系人"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    staticClass: "align-left",
                    attrs: {
                      prop: "buyerContactTel",
                      width: "100",
                      label: "机构联系电话"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    staticClass: "align-left",
                    attrs: {
                      prop: "creatorName",
                      width: "100",
                      label: "请求人"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    staticClass: "align-left",
                    attrs: {
                      label: "设备名称",
                      prop: "goodsTitle",
                      width: "150",
                      "show-overflow-tooltip": ""
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    staticClass: "align-left",
                    attrs: {
                      label: "系统编号",
                      width: "250",
                      "show-overflow-tooltip": ""
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(rows) {
                          return [
                            _c("span", [
                              _c(
                                "a",
                                {
                                  staticClass: "swb-btn-link",
                                  on: {
                                    click: function($event) {
                                      $event.stopPropagation()
                                      _vm.gotoShopDeviceSvcSubNo(rows.row.tmpNo)
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(rows.row.tmpNo))]
                              )
                            ])
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    staticClass: "align-left",
                    attrs: {
                      label: "所属套装",
                      prop: "suitName",
                      width: "100",
                      "show-overflow-tooltip": ""
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    staticClass: "align-left",
                    attrs: {
                      label: "分类名称",
                      prop: "goodsCatName",
                      width: "150",
                      "show-overflow-tooltip": ""
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    staticClass: "align-left",
                    attrs: {
                      label: "服务名称",
                      prop: "title",
                      width: "150",
                      "show-overflow-tooltip": ""
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    staticClass: "align-left",
                    attrs: { label: "服务号", prop: "svcNo", width: "150" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    staticClass: "align-left",
                    attrs: { label: "服务子号", "min-width": "160" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(rows) {
                          return [
                            _c("span", [_vm._v(_vm._s(rows.row.svcSubNo))]),
                            _vm._v(" "),
                            rows.row.beyondWrnt && rows.row.svcSubNo != null
                              ? _c("i", { staticClass: "swb-icon table-wrnt" })
                              : !rows.row.beyondWrnt &&
                                rows.row.svcSubNo != null
                              ? _c("i", {
                                  staticClass: "swb-icon table-unWrnt"
                                })
                              : _vm._e()
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    staticClass: "align-left ",
                    attrs: { label: "请求单号", prop: "no", "min-width": "160" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    staticClass: "align-left ",
                    attrs: { label: "是否保养", "min-width": "80" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(rows) {
                          return [
                            rows.row.maintFlag
                              ? _c("el-tag", { attrs: { type: "danger" } }, [
                                  _vm._v("保养")
                                ])
                              : _vm._e()
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    staticClass: "align-left",
                    attrs: { label: "状态", prop: "state", width: "80" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    staticClass: "align-left",
                    attrs: {
                      label: "服务商家",
                      prop: "dstSevicerName",
                      width: "150",
                      "show-overflow-tooltip": ""
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    staticClass: "align-left",
                    attrs: {
                      label: "服务网点",
                      prop: "servicerComName",
                      width: "150",
                      "show-overflow-tooltip": ""
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    staticClass: "align-left",
                    attrs: {
                      label: "网点联系人",
                      prop: "dstContactName",
                      width: "80"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    staticClass: "align-left",
                    attrs: {
                      label: "网点联系电话",
                      prop: "dstContactTel",
                      width: "100"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: "操作",
                      fixed: "right",
                      align: "left",
                      width: "100"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(rows) {
                          return [
                            rows.row.tmpNo != null
                              ? _c(
                                  "a",
                                  {
                                    staticClass: "swb-btn swb-btn-link",
                                    on: {
                                      click: function($event) {
                                        _vm.showDeviceRepairRec(rows.row.tmpNo)
                                      }
                                    }
                                  },
                                  [_vm._v("维保记录")]
                                )
                              : _vm._e()
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "block pagination-layout" },
            [
              _c("el-pagination", {
                staticClass: "mt10",
                attrs: {
                  background: "",
                  "page-size": _vm.pageSize,
                  "page-sizes": _vm.pageSizes,
                  "current-page": _vm.pageNumber,
                  total: _vm.totalCount,
                  layout: "total, sizes, prev, pager, next, jumper"
                },
                on: {
                  "current-change": _vm.handlePageChange,
                  "size-change": _vm.handleSizeChange
                }
              })
            ],
            1
          )
        ]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("button", { staticClass: "swb-btn swb-btn-link" }, [
      _c("i", { staticClass: "icon iconfont icon-fanhui2 mr5" }),
      _vm._v("返回")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "tab-container base" }, [
      _c("div", { staticClass: "tabs-nav" }, [
        _c("ul", { staticClass: "head" }, [
          _c("li", { staticClass: "head-item current" }, [_vm._v("组织机构")])
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2318adec", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2318adec","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/retailer/DeviceMalfunctionStatisList.vue
// module id = 3073
// module chunks = 0